import { Link } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="no-underline">
              <h3 className="font-heading text-xl font-bold text-white mb-4">
                {siteConfig.name}
              </h3>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {siteConfig.tagline} — 与全国玩家同台竞技，展现你的实力，赢取丰厚奖励！
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-white transition-colors no-underline cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/rules" className="text-sm text-foreground-300 hover:text-white transition-colors no-underline cursor-pointer">赛事规则</Link>
              </li>
              <li>
                <Link to="/category/guide" className="text-sm text-foreground-300 hover:text-white transition-colors no-underline cursor-pointer">参赛指南</Link>
              </li>
              <li>
                <Link to="/category/prizes" className="text-sm text-foreground-300 hover:text-white transition-colors no-underline cursor-pointer">奖品详情</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-white transition-colors no-underline cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-base"></i>
                <span>support@17.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-1717</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-wechat-line text-base"></i>
                <span>17cn_official</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} {siteConfig.name}. 保留所有权利。
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-foreground-400 hover:text-white transition-colors no-underline cursor-pointer">关于我们</Link>
            <Link to="/category/rules" className="text-xs text-foreground-400 hover:text-white transition-colors no-underline cursor-pointer">赛制规则</Link>
            <Link to="/category/guide" className="text-xs text-foreground-400 hover:text-white transition-colors no-underline cursor-pointer">参赛指南</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}